module.exports = __webpack_public_path__ + "img/logo-think.eb1b2a48.png";